import _regeneratorRuntime from "/app/store-locator/node_modules/next/node_modules/@babel/runtime/regenerator";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _asyncToGenerator from "/app/store-locator/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { LoadingOutlined } from '@ant-design/icons';
import { Button, Form, Spin } from 'antd';
import { Input } from 'antd';
import IconGps from 'core/assets/icon/gps.svg';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { template, TEMPLATE_SEARCH_IMAGE_BACKGROUND_MAP, theme } from 'src/template';
import styled from 'styled-components';
import { getGeolocation } from 'utils/geolocation';

/** Component to pick an address. */
export var AddressPicker = function AddressPicker(_ref) {
  var onGetPosition = _ref.onGetPosition,
      _onChange = _ref.onChange;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(false),
      isLoadingGPS = _useState[0],
      setLoadingGPS = _useState[1];

  function getCurrentPosition() {
    return _getCurrentPosition.apply(this, arguments);
  }

  function _getCurrentPosition() {
    _getCurrentPosition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _location;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoadingGPS(true);
              _context.prev = 1;
              _context.next = 4;
              return getGeolocation();

            case 4:
              _location = _context.sent;
              onGetPosition(_location);

            case 6:
              _context.prev = 6;
              setLoadingGPS(false);
              return _context.finish(6);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1,, 6, 9]]);
    }));
    return _getCurrentPosition.apply(this, arguments);
  }

  return /*#__PURE__*/_jsxs(Container, {
    label: t('restaurant.findRestaurant'),
    name: "search",
    children: [/*#__PURE__*/_jsx(Input, {
      placeholder: t('restaurant.searchRestaurant'),
      onChange: function onChange(e) {
        return _onChange(e.target.value);
      }
    }), /*#__PURE__*/_jsx(Button, {
      className: "button-gps",
      type: "link",
      onClick: function onClick() {
        return getCurrentPosition();
      },
      disabled: isLoadingGPS,
      children: isLoadingGPS ? /*#__PURE__*/_jsx(Spin, {
        indicator: /*#__PURE__*/_jsx(LoadingOutlined, {
          style: {
            fontSize: 12
          },
          spin: true
        })
      }) : /*#__PURE__*/_jsx(IconGps, {})
    })]
  });
}; // Styles

var backgroundImage = TEMPLATE_SEARCH_IMAGE_BACKGROUND_MAP[template.name];
var Container = styled(Form.Item).withConfig({
  displayName: "AddressPicker__Container",
  componentId: "sc-gg264o-0"
})(["background-color:", ";background-image:url(", ");background-position:center center;background-size:cover;display:flex;margin:0;padding:20px;.ant-form-item-control-input-content{align-items:center;display:flex;}.ant-input{border-radius:10px;height:56px;::placeholder,::-webkit-input-placeholder{color:#333;}:-ms-input-placeholder{color:#333;}}.button-gps{background:", ";border-radius:10px;display:flex;align-items:center;margin:0 12px;height:56px;width:56px;svg *{stroke:", ";}}&.ant-row{display:block;}.ant-form-item-label{label{color:#fff;font-size:32px;font-weight:700;line-height:110%;margin-bottom:24px;margin-top:24px;text-transform:uppercase;&::after{content:'';}}margin-bottom:24px;max-width:100%;overflow:visible;text-align:left;white-space:normal;width:400px;}"], theme.colors.black, backgroundImage, theme.colors.secondary, theme.colors.inputContrast);